<template lang="pug">
div
    BaseHeader(
        :titulo='$t("mensagens.gerenteComercial.labels.titulo")',
        :voltarPara='{ route: "ConfiguracaoGerentesComerciais" }'
    )
    .formulario-gerente-comercial
        h3.formulario-gerente-comercial__titulo {{ $t('mensagens.gerenteComercial.labels.dadosCadastrais') }}
        .formulario-gerente-comercial__card
            .select-field(v-if='isBunge')
                label.select-field__label {{ $t('mensagens.gerenteComercial.labels.gerenteRegional') }}
                el-select.select-field__input(
                    :loading='carregandoGerentesRegionais',
                    :placeholder='$t("mensagens.comuns.selecione")',
                    v-model='gerenteComercial.idGerenteRegional',
                    clearable,
                    filterable
                )
                    el-option(
                        v-for='({ nome, id }, index) in gerentesRegionais',
                        :key='`gerente-regional-${id}-${index}`',
                        :label='nome',
                        :value='id'
                    )

            .input-field
                label.input-field__label.obrigatorio {{ $t('mensagens.gerenteComercial.labels.idBunge') }}
                input.input-field__input(
                    :placeholder='$t("mensagens.gerenteComercial.labels.descricaoId")',
                    v-model='gerenteComercial.idBunge'
                )
            .input-field
                label.input-field__label.obrigatorio {{ $t('mensagens.gerenteComercial.labels.nome') }}
                input.input-field__input(
                    :placeholder='$t("mensagens.gerenteComercial.labels.descricao")',
                    v-model='gerenteComercial.nome'
                )
        h3.formulario-gerente-comercial__titulo(v-if='isBunge') {{ $t('mensagens.gerenteComercial.labels.dadosVinculados') }}
        .formulario-gerente-comercial__card.handler(v-if='isBunge')
            FormularioHandler(:titulo='tituloGerenteTerritorial()', aberto)
                MultiselectTable(
                    tableId='gerentes-territoriais-table',
                    :label='formatarGerenteTerritorial()',
                    v-model='idsGerentesTerritoriais',
                    :options='gerentesTerritoriais',
                    :loading='carregandoGerentesTerritoriais',
                    :buttonAddLabel='$t("mensagens.gerenteComercial.labels.adicionarGerenteTerritorial")',
                    :buttonRouteLabel='$t("mensagens.gerenteComercial.labels.criarGerenteTerritorial")',
                    :alertMessageAdd='$t("mensagens.gerenteComercial.labels.alertaAdicionarGerenteTerritorial")',
                    routeName='CadastroGerenteTerritorial'
                )

        .footer
            .footer__btn.voltar(@click='irParaConfiguracaoGerentesComerciais')
                i.mdi.mdi-arrow-left
                span {{ $t('mensagens.comuns.voltar') }}
            .footer__btn.salvar(@click='fluxoSalvarGerenteComercial')
                span {{ $t('mensagens.comuns.salvar') }}
                i.mdi.mdi-arrow-right
</template>

<script>
import services from '@/services/ContratoOriginacaoService';
import EventBus from '@/utils/eventBus';
import { mapGetters } from 'vuex';

export default {
    name: 'FormularioGerenteComercial',
    props: ['row'],
    components: {
        BaseHeader: () => import('@/components/BaseHeader'),
        FormularioHandler: () =>
            import('@/components/contratosOriginacao/formulario/Handler'),
        MultiselectTable: () =>
            import(
                '@/components/contratosOriginacao/formulario/MultiselectTable'
            )
    },
    data() {
        return {
            gerenteComercial: {
                id: '',
                nome: '',
                idBunge: '',
                idGerenteRegional: '',
                idsGerentesTerritoriais: []
            },
            idsGerentesTerritoriais: [],
            gerentesRegionais: [],
            gerentesTerritoriais: [],
            carregandoGerentesRegionais: false,
            carregandoGerentesTerritoriais: false,
            handlerAberto: false
        };
    },

    mounted() {
        this.carregarListasGerentes();
        this.preencherCamposEdicao();
    },

    computed: {
        ...mapGetters(['usuarioLogado']),
        formularioValido() {
            return (
                !!this.gerenteComercial.nome &&
                !!this.gerenteComercial.idGerenteRegional
            );
        },
        isBunge() {
            return this.usuarioLogado.isBunge;
        }
    },

    methods: {
        async carregarListasGerentes() {
            this.loadingScreen(true);
            await this.buscarGerentesTerritoriais();
            await this.buscarGerentesRegionais();
            this.loadingScreen(false);
        },
        preencherCamposEdicao() {
            if (this.row?.id) {
                const idsGerentesTerritoriais =
                    this.row.idsGerentesTerritoriais || [];

                this.gerenteComercial = {
                    id: this.row.id,
                    nome: this.row.nome,
                    idBunge: this.row.idBunge,
                    idGerenteRegional: this.row.idGerenteRegional,
                    idsGerentesTerritoriais: this.row.idsGerentesTerritoriais
                };
                this.idsGerentesTerritoriais = idsGerentesTerritoriais;
                this.handlerAberto = idsGerentesTerritoriais.length > 0;
            }
        },
        buscarGerentesRegionais() {
            this.carregandoGerentesRegionais = true;
            return services
                .buscarGerentesRegionais()
                .then(({ data }) => {
                    if (data.length > 0) {
                        this.gerentesRegionais = data;
                    }
                })
                .finally(() => {
                    this.carregandoGerentesRegionais = false;
                });
        },
        buscarGerentesTerritoriais() {
            this.carregandoGerentesTerritoriais = true;
            return services
                .buscarGerentesTerritoriais()
                .then(({ data }) => {
                    if (data.length > 0) {
                        this.gerentesTerritoriais = data;
                    }
                })
                .finally(() => {
                    this.carregandoGerentesTerritoriais = false;
                });
        },
        irParaConfiguracaoGerentesComerciais() {
            this.$router.push({ name: 'ConfiguracaoGerentesComerciais' });
        },
        fluxoSalvarGerenteComercial() {
            const nomeInvalido = !this.gerenteComercial.nome;
            const idBungeInvalido = !this.gerenteComercial.idBunge;
            const mensagemNomeVazio = this.$t(
                'mensagens.gerenteComercial.labels.nomeVazio'
            );
            const mensagemIDBungeVazio = this.$t(
                'mensagens.gerenteComercial.labels.idBungeVazio'
            );

            if (idBungeInvalido) {
                return this.$notify.error(mensagemIDBungeVazio);
            }
            if (nomeInvalido) {
                return this.$notify.error(mensagemNomeVazio);
            }
            if (this.row?.id) {
                this.editarGerenteComercial();
            } else {
                this.cadastrarGerenteComercial();
            }
        },
        cadastrarGerenteComercial() {
            const mensagemSucesso = this.$t(
                'mensagens.gerenteComercial.labels.registroCadastrado'
            );
            const params = {
                nome: this.gerenteComercial.nome,
                idBunge: this.gerenteComercial.idBunge,
                idGerenteRegional: this.gerenteComercial.idGerenteRegional
            };

            if (this.idsGerentesTerritoriais.length > 0) {
                params.idsGerentesTerritoriais = this.idsGerentesTerritoriais;
            }
            services.cadastrarGerenteComercial(params).then(() => {
                this.$notify.success(mensagemSucesso);
                this.irParaConfiguracaoGerentesComerciais();
            });
        },
        editarGerenteComercial() {
            const mensagemSucesso = this.$t(
                'mensagens.gerenteComercial.labels.registroEditado'
            );
            const params = {
                id: this.gerenteComercial.id,
                nome: this.gerenteComercial.nome,
                idBunge: this.gerenteComercial.idBunge,
                idGerenteRegional: this.gerenteComercial.idGerenteRegional
            };

            if (this.idsGerentesTerritoriais.length > 0) {
                params.idsGerentesTerritoriais = this.idsGerentesTerritoriais;
            }
            services.editarGerenteComercial(params).then(() => {
                this.$notify.success(mensagemSucesso);
                this.irParaConfiguracaoGerentesComerciais();
            });
        },
        formatarGerenteTerritorial() {
            return this.idsGerentesTerritoriais.length > 1
                ? this.$t(
                      'mensagens.gerenteComercial.labels.gerentesTerritoriais'
                  )
                : this.$t(
                      'mensagens.gerenteComercial.labels.gerenteTerritorial'
                  );
        },
        tituloGerenteTerritorial() {
            const gerentesTerritoriais = this.$t(
                'mensagens.gerenteComercial.labels.gerentesTerritoriais'
            );
            const opcional = this.$t(
                'mensagens.gerenteComercial.labels.opcional'
            );

            return `${gerentesTerritoriais} (${opcional})`;
        },
        loadingScreen(isLoading) {
            const options = {
                mostrarLoading: isLoading,
                lockMessage: this.$t('mensagens.sistema.carregando')
            };
            EventBus.$emit('emit-componente-carregando', options);
        }
    }
};
</script>

<style lang="scss">
.formulario-gerente-comercial {
    margin: 20px;

    &__titulo {
        margin-top: 24px;
        font-weight: 500;
    }

    &__card {
        margin-top: 10px;
        background-color: $white;
        padding: 16px;
        display: flex;
        flex-direction: column;
        gap: 20px;
        border-radius: $default-border-radius;
        @include default-box-shadow();

        &.handler {
            padding: 0;
        }
    }

    .select-field {
        width: 50%;
        display: flex;
        flex-direction: column;
        gap: 3px;

        &__label {
            color: $primary;
            font-weight: bold;
        }

        &__input {
            height: 40px;
            border-radius: $default-border-radius;
            outline: 0;

            & input {
                color: var(--primary-font-color) !important;

                &:disabled {
                    color: #545454 !important;
                }
            }
        }
    }

    .input-field {
        width: 50%;
        display: flex;
        flex-direction: column;
        gap: 3px;

        &__label {
            color: $primary;
            font-weight: bold;
        }

        &__input {
            height: 40px;
            width: 100%;
            border-radius: $default-border-radius;
            border: 1px solid $default-border-color;
            outline: 0;
            padding: 0 15px;
        }
    }

    .obrigatorio::after {
        content: '* ';
        color: red;
        margin-left: 3px;
    }
}

.footer {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    gap: 8px;
}

.footer__btn {
    width: 100px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    border-radius: $default-border-radius;
    cursor: pointer;

    .mdi-arrow-left {
        color: var(--primary);
    }

    .mdi-arrow-right {
        color: $white;
    }
}

.salvar {
    background-color: var(--primary);
    color: $white;
}

.salvar:hover {
    background-color: var(--secondary);
}

.footer__btn.voltar {
    background-color: transparent;
    color: var(--primary);
    border: 1px solid var(--primary);
}

.footer__btn.voltar:hover {
    background-color: var(--primary);
    color: $white;

    .mdi-arrow-left {
        color: $white;
    }
}
</style>
